export default __webpack_public_path__ + "static/case1_img_2@2x-47670b8753927f5c86df36a0bbfea630.webp";